/**
 * Wraps a keydown handler so IME composition keeps its keys. An IME sends
 * Enter to accept the candidate it is offering, Escape to reject it, and the
 * arrows to move through its candidate window — while the wrapped handler
 * would commit, unmount, or move a highlight on those same keys, taking the
 * half-typed word with it. Every editing input that commits on Enter routes
 * its keydown through this rather than growing its own isComposing check.
 */
export function unlessComposing<Event extends { nativeEvent: { isComposing: boolean } }>(
   handler: (event: Event) => void
): (event: Event) => void {
   return event => {
      if (event.nativeEvent.isComposing) {
         return;
      }
      handler(event);
   };
}
